module.exports = __webpack_public_path__ + "static/media/Card_Data_Analytics.660fdb6d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banners/courses/dataAnalytics/Card_Data_Analytics.png
// module id = 103
// module chunks = 0